import React from 'react';
import PropTypes from 'prop-types';
import { Button, Heading, Box, Flex } from '@front/gatsby-ui';
import { setAssignmentOrder } from '@front/blocks/src/order-assignment';
import Container from 'Components/container';

import bgLeft from 'Img/bg-cta--left.svg';
import bgRight from 'Img/bg-cta--right.svg';

const CtaBlock = ({ ctaText, buttonText, scroll, sx, ...rest }) => (
  <Box
    sx={{
      backgroundColor: 'secondary.0',
      position: 'relative',
      zIndex: 1,

      '&::before,&::after': {
        content: '""',
        position: 'absolute',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        zIndex: -1,
      },

      '&::before': {
        width: '278px',
        height: '176px',
        bottom: 0,
        left: '0px',
        backgroundImage: `url(${bgLeft})`,
      },

      '&::after': {
        width: '278px',
        height: '148px',
        top: 0,
        right: '0px',
        backgroundImage: `url(${bgRight})`,
      },
      ...sx,
    }}
    {...rest}
  >
    <Container
      py={{ _: 4, md: '48px' }}
      maxWidth="820px"
    >
      <Box
        display={{ _: 'block', md: 'flex' }}
        margin="0 auto"
        justifyContent={{ md: 'space-between' }}
      >
        <Heading
          flex="1 0 auto"
          as="h2"
          variant="h2"
          maxWidth={{ md: '550px' }}
          color="basic.0"
          textAlign={{ _: 'center', md: 'left' }}
          mb={{ _: 4, md: 0 }}
        >
          {ctaText}
        </Heading>
        <Flex
          alignItems="center"
          flex="1 0 auto"
          justifyContent="center"
        >
          <Button
            sx={{
              fontSize: 'button',
              color: 'basic.5',
              fontWeight: 'bold',
              bg: 'basic.0',
              borderRadius: 'small',
              textAlign: 'center',
              cursor: 'pointer',

              '&:hover, &:focus': {
                bg: 'basic.1',
                outline: 0,
              },

              '&:active, &:focus': {
                borderColor: 'secondary.0',
                bg: 'secondary.1',
              },

              '&:disabled': {
                color: 'basic.3',
                borderColor: 'basic.3',
                cursor: 'not-allowed',
              },
            }}
            onClick={scroll || (() => setAssignmentOrder({ threshold: 250 }))}
          >
            {buttonText}
          </Button>
        </Flex>
      </Box>
    </Container>
  </Box>
);

CtaBlock.propTypes = {
  ctaText: PropTypes.string,
  buttonText: PropTypes.string,
  sx: PropTypes.shape({}),
  scroll: PropTypes.func,
};

CtaBlock.defaultProps = {
  ctaText: 'Let us have your assignment done in no time!',
  buttonText: 'Order now',
  sx: {},
  scroll: null,
};

export default CtaBlock;
